<template>
  <div class="stripe lockdown active">
    <!-- Active -->
    <div class="active">
      <img src="@/assets/img/lockdown.svg" alt="Lockdown" />
      <span>Lockdown ends in {{ lockTime }} days</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "LockTimeLeft",
  components: {},
  props: {},
  computed: {
    time: function() {
      return this.$store.state.time;
    },

    lockTime: function() {
      return this.$store.state.lockTime;
    },
  },

  data() {
    return {};
  },

  watch: {
    time: function() {},
  },

  mounted: function() {},

  methods: {
    stopLockDown: function() {},
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/vars.scss";
.stripe {
  width: 100%;
  background: $gray800;
  color: #fff;
  padding: 8px 16px;
  transition: 0.2s;

  > div {
    display: flex;
    align-items: center;
  }

  .ready {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;

    div {
      flex-direction: row;
    }
  }

  img {
    margin-right: 8px;
  }
  .inactive {
    background: $gray800;
  }
}

.available,
.active {
  background: $orange;
  span {
    font-weight: 600;
  }
}
</style>
